import { useEffect, useState } from 'react';
import axios from 'axios';
import { Award, Building2, User } from 'lucide-react';
import { API, fmtDate } from './stars';

const Event = ({ h, showName }) => {
  const won = h.event === 'kazandi';
  const label = h.entity_type === 'company' ? 'Altın Firma' : 'Altın Personel';
  const Icon = h.entity_type === 'company' ? Building2 : User;
  return (
    <div className="relative pl-6" data-testid={`gold-history-${h.id}`}>
      <span className={`absolute left-0 top-1.5 h-3 w-3 rounded-full ring-4 ${won ? 'bg-amber-400 ring-amber-100' : 'bg-slate-400 ring-slate-100'}`} />
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <span className="text-xs text-slate-500">{fmtDate(h.created_at)} {h.created_at?.slice(11, 16)}</span>
        <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${won ? 'bg-gradient-to-b from-yellow-200 via-yellow-400 to-amber-500 text-amber-950' : 'bg-slate-200 text-slate-600'}`} data-testid={`gold-history-event-${h.id}`}>
          {won ? `${label} rozetini kazandı` : `${label} rozetini kaybetti`}
        </span>
        {showName && <span className="flex items-center gap-1 font-semibold text-slate-800"><Icon className="h-3.5 w-3.5 text-slate-400" />{h.name}{h.entity_type === 'employee' && <span className="font-normal text-slate-500">· {h.company_name}</span>}</span>}
      </div>
      <p className="mt-0.5 text-xs text-slate-500">
        Ortalama {h.avg ?? '-'} / 5 · {h.jobs} iş · Şart: {h.gold_avg}+ ve en az {h.gold_jobs} iş · Neden: {h.reason}
      </p>
    </div>
  );
};

export const GoldHistory = ({ entityId, showName = false, filter = 'all' }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get(`${API}/five-star/gold-history`, { params: entityId ? { entity_id: entityId } : {} }).then(r => setRows(r.data)).catch(() => setRows([]));
  }, [entityId]);
  if (!rows) return <p className="text-sm text-slate-400">Yükleniyor...</p>;
  const list = rows.filter(r => filter === 'all' || r.entity_type === filter);
  return (
    <div data-testid={entityId ? `gold-timeline-${entityId}` : 'gold-history-list'}>
      {entityId && <p className="mb-2 flex items-center gap-1 text-sm font-semibold text-slate-800"><Award className="h-4 w-4 text-amber-500" />Rozet Geçmişi</p>}
      {list.length === 0 ? <p className="rounded-lg border p-3 text-sm text-slate-400">Henüz rozet hareketi yok</p> : (
        <div className="space-y-3 border-l border-slate-200 pl-1">{list.map(h => <Event key={h.id} h={h} showName={showName} />)}</div>
      )}
    </div>
  );
};

export const GoldHistoryTab = () => {
  const [filter, setFilter] = useState('all');
  const opts = [['all', 'Tümü'], ['company', 'Firmalar'], ['employee', 'Personel']];
  return (
    <div className="space-y-4 rounded-lg border bg-white p-4" data-testid="gold-history-tab">
      <div className="flex gap-2">
        {opts.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setFilter(k)} data-testid={`gold-history-filter-${k}`}
            className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${filter === k ? 'bg-amber-500 text-amber-950' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}>{l}</button>
        ))}
      </div>
      <GoldHistory showName filter={filter} />
    </div>
  );
};
